// extracted by mini-css-extract-plugin
export var current = "SecondaryTopNav-module--current--395a7";
export var currentLink = "SecondaryTopNav-module--currentLink--76922";
export var label = "SecondaryTopNav-module--label--9827d";
export var li = "SecondaryTopNav-module--li--1298b";
export var link = "SecondaryTopNav-module--link--9fe79";
export var secondary = "SecondaryTopNav-module--secondary--212f1";
export var ul = "SecondaryTopNav-module--ul--701bd";